import {DirectGeometryObject} from 'geojson';

export class Utils {
  // Convert geojson to wkt fomat
  static geojsonToWKT(geojson: any, geomType?: string): string {
    // TODO: сделать нормальное преобразование к multi типам
    if (geojson.geometry) {
      geojson = geojson.geometry;
    }

    const type = geomType ? geomType.toLowerCase() : geojson.type.toLowerCase();

    let lng = '';
    let lat = '';
    const coordinates = Array<string>();
    switch (type) {
      case 'polygon':
        geojson.coordinates[0].forEach((coords: string[], idx: number) => {
          coordinates.push(coords[0] + ' ' + coords[1]);
          if (idx === 0) {
            lng = coords[0];
            lat = coords[1];
          }
        });
        return 'POLYGON((' + coordinates.join(',') + ',' + lng + ' ' + lat + '))';
      case 'multipolygon':
        const polygon: any = geojson.coordinates[0][0][0][0] ? geojson.coordinates[0][0] : geojson.coordinates[0];
        polygon.forEach((coords: string[], idx: number) => {
          coordinates.push(coords[0] + ' ' + coords[1]);
          if (idx === 0) {
            lng = coords[0];
            lat = coords[1];
          }
        });
        return 'Multipolygon(((' + coordinates.join(',') + ',' + lng + ' ' + lat + ')))';
      case 'polyline':
      case 'linestring':
        geojson.coordinates.forEach((coords: string[], idx: number) => {
          coordinates.push(coords[0] + ' ' + coords[1]);
        });
        return 'LINESTRING(' + coordinates.join(',') + ')';
      case 'multilinestring':
        const linestring: any = geojson.coordinates[0][0][0] ? geojson.coordinates[0] : geojson.coordinates;
        linestring.coordinates.forEach((coords: string[], idx: number) => {
          coordinates.push(coords[0] + ' ' + coords[1]);
        });
        return 'MULTILINESTRING ((' + coordinates.join(',') + '))';

      case 'point':
        return 'POINT(' + geojson.coordinates[0] + ' ' + geojson.coordinates[1] + ')';
      case 'multipoint':
        const point: any = geojson.coordinates[0][0][0] ? geojson.coordinates[0] : geojson.coordinates;
        return 'MULTIPOINT ((' + point[0] + ' ' + point[1] + '))';
    }
  }

  static mixin(mixTo: object, mixFrom: object) {
    for (const key in mixFrom) {
      mixTo[key] = mixFrom[key];
    }
  }

  static parseWKT(input: string): DirectGeometryObject {
    const tuples = new RegExp(
      '^' +
        /[-+]?([0-9]*\.[0-9]+|[0-9]+)([eE][-+]?[0-9]+)?/.source +
        '(\\s' +
        /[-+]?([0-9]*\.[0-9]+|[0-9]+)([eE][-+]?[0-9]+)?/.source +
        '){1,}'
    );
    const parts = input.split(';');
    let _ = parts.pop();
    const srid = (parts.shift() || '').split('=').pop();

    let i = 0;

    function $(re: any) {
      const match = _.substring(i).match(re);
      if (!match) {
        return null;
      } else {
        i += match[0].length;
        return match[0];
      }
    }

    function crs(obj: any) {
      if (obj && srid.match(/\d+/)) {
        obj.crs = {
          type: 'name',
          properties: {
            name: 'urn:ogc:def:crs:EPSG::' + srid
          }
        };
      }

      return obj;
    }

    function white() {
      $(/^\s*/);
    }

    function multicoords() {
      white();
      let depth = 0;
      const rings: any[] = [];
      const stack = [rings];
      let pointer = rings;
      let elem;

      // tslint:disable-next-line:no-conditional-assignment
      while ((elem = $(/^(\()/) || $(/^(\))/) || $(/^(,)/) || $(tuples))) {
        if (elem === '(') {
          stack.push(pointer);
          pointer = [];
          stack[stack.length - 1].push(pointer);
          depth++;
        } else if (elem === ')') {
          // For the case: Polygon(), ...
          if (pointer.length === 0) {
            return null;
          }

          pointer = stack.pop();
          // the stack was empty, input was malformed
          if (!pointer) {
            return null;
          }
          depth--;
          if (depth === 0) {
            break;
          }
        } else if (elem === ',') {
          pointer = [];
          stack[stack.length - 1].push(pointer);
        } else if (!elem.split(/\s/g).some(isNaN as any)) {
          Array.prototype.push.apply(pointer, elem.split(/\s/g).map(parseFloat));
        } else {
          return null;
        }
        white();
      }

      if (depth !== 0) {
        return null;
      }

      return rings;
    }

    function coords() {
      const list = [];
      let item: any;
      let pt;
      // tslint:disable-next-line:no-conditional-assignment
      while ((pt = $(tuples) || $(/^(,)/))) {
        if (pt === ',') {
          list.push(item);
          item = [];
        } else if (!pt.split(/\s/g).some(isNaN as any)) {
          if (!item) {
            item = [];
          }
          Array.prototype.push.apply(item, pt.split(/\s/g).map(parseFloat));
        }
        white();
      }

      if (item) {
        list.push(item);
      } else {
        return null;
      }

      return list.length ? list : null;
    }

    function point() {
      if (!$(/^(point(\sz)?)/i)) {
        return null;
      }
      white();
      if (!$(/^(\()/)) {
        return null;
      }
      const c = coords();
      if (!c) {
        return null;
      }
      white();
      if (!$(/^(\))/)) {
        return null;
      }
      return {
        type: 'Point',
        coordinates: c[0]
      };
    }

    function multipoint() {
      if (!$(/^(multipoint)/i)) {
        return null;
      }
      white();
      const newCoordsFormat = _.substring(_.indexOf('(') + 1, _.length - 1)
        .replace(/\(/g, '')
        .replace(/\)/g, '');
      _ = 'MULTIPOINT (' + newCoordsFormat + ')';
      const c = multicoords();
      if (!c) {
        return null;
      }
      white();
      return {
        type: 'MultiPoint',
        coordinates: c
      };
    }

    function multilinestring() {
      if (!$(/^(multilinestring)/i)) {
        return null;
      }
      white();
      const c = multicoords();
      if (!c) {
        return null;
      }
      white();
      return {
        type: 'MultiLineString',
        coordinates: c
      };
    }

    function linestring() {
      if (!$(/^(linestring(\sz)?)/i)) {
        return null;
      }
      white();
      if (!$(/^(\()/)) {
        return null;
      }
      const c = coords();
      if (!c) {
        return null;
      }
      if (!$(/^(\))/)) {
        return null;
      }
      return {
        type: 'LineString',
        coordinates: c
      };
    }

    function polygon() {
      if (!$(/^(polygon(\sz)?)/i)) {
        return null;
      }
      white();
      const c = multicoords();
      if (!c) {
        return null;
      }
      return {
        type: 'Polygon',
        coordinates: c
      };
    }

    function multipolygon() {
      if (!$(/^(multipolygon)/i)) {
        return null;
      }
      white();
      const c = multicoords();
      if (!c) {
        return null;
      }
      return {
        type: 'MultiPolygon',
        coordinates: c
      };
    }

    function geometrycollection() {
      const geometries = [];
      let geometry;

      if (!$(/^(geometrycollection)/i)) {
        return null;
      }
      white();

      if (!$(/^(\()/)) {
        return null;
      }

      // tslint:disable-next-line:no-conditional-assignment
      while ((geometry = root())) {
        geometries.push(geometry);
        white();
        $(/^(,)/);
        white();
      }
      if (!$(/^(\))/)) {
        return null;
      }

      return {
        type: 'GeometryCollection',
        geometries
      };
    }

    function root(): any {
      return point() || linestring() || polygon() || multipoint() || multilinestring() || multipolygon() || geometrycollection();
    }

    return crs(root());
  }

  /**
   * Stringifies a GeoJSON object into WKT
   */
  static stringifyWKT(gj: any) {
    if (gj.type === 'Feature') {
      gj = gj.geometry;
    }

    function pairWKT(c: any) {
      return c.join(' ');
    }

    function ringWKT(r: any) {
      return r.map(pairWKT).join(', ');
    }

    function ringsWKT(r: any) {
      return r
        .map(ringWKT)
        .map(wrapParens)
        .join(', ');
    }

    function multiRingsWKT(r: any) {
      return r
        .map(ringsWKT)
        .map(wrapParens)
        .join(', ');
    }

    function wrapParens(s: any) {
      return '(' + s + ')';
    }

    switch (gj.type) {
      case 'Point':
        return 'POINT (' + pairWKT(gj.coordinates) + ')';
      case 'LineString':
        return 'LINESTRING (' + ringWKT(gj.coordinates) + ')';
      case 'Polygon':
        return 'POLYGON (' + ringsWKT(gj.coordinates) + ')';
      case 'MultiPoint':
        return 'MULTIPOINT (' + ringWKT(gj.coordinates) + ')';
      case 'MultiPolygon':
        return 'MULTIPOLYGON (' + multiRingsWKT(gj.coordinates) + ')';
      case 'MultiLineString':
        return 'MULTILINESTRING (' + ringsWKT(gj.coordinates) + ')';
      case 'GeometryCollection':
        return 'GEOMETRYCOLLECTION (' + gj.geometries.map(this.stringifyWKT).join(', ') + ')';
      default:
        throw new Error('stringify requires a valid GeoJSON Feature or geometry object as input');
    }
  }

  static sortByKey(key: string, order: string = 'asc') {
    if (order === 'asc') {
      return (a: object, b: object) => {
        if (a[key].toLowerCase() > b[key].toLowerCase()) {
          return 1;
        }
        if (a[key].toLowerCase() < b[key].toLowerCase()) {
          return -1;
        }
        return 0;
      };
      // От меньшего к большему
    } else {
      return (a: object, b: object) => {
        const aLower = a[key].toLowerCase();
        const bLower = b[key].toLowerCase();
        return aLower < bLower ? 1 : aLower > bLower ? -1 : 0;
      };
    }
  }

  static sortByKeys(key1: string, key2: string = null) {
    return (a: object, b: object) => {
      const a1Lower = a[key1].toLowerCase();
      const b1Lower = b[key1].toLowerCase();
      if (a1Lower > b1Lower) {
        return 1;
      }
      if (a1Lower < b1Lower) {
        return -1;
      }
      if (!key2) {
        return 0;
      }
      const a2Lower = a[key2].toLowerCase();
      const b2Lower = b[key2].toLowerCase();
      return a2Lower > b2Lower ? 1 : a2Lower < b2Lower ? -1 : 0;
    };
  }

  static getDateWithTimezoneOffset(date: Date) {
    return new Date(date.getTime() - date.getTimezoneOffset() * 60000);
  }

  static getISOString(date: Date): string {
    return this.getDateWithTimezoneOffset(date).toISOString();
  }

  static getDateString(date: Date): string {
    return this.getISOString(date).substring(0, 10);
  }

  static hexColorToRGBA(hex: string, alfa: number): string {
      const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})/i.exec(hex);
      const ret = result ? `rgba(${parseInt(result[1], 16)}, ${parseInt(result[2], 16)}, ${parseInt(result[3], 16)}, ${alfa})` : null;
      return ret;
  }

  static getRelativePosition(elt: HTMLElement, selector: string): {left: number, right: number, top: number, bottom: number} {
    const ret = {left: 0, top: 0, bottom: 0, right: 0};
    let currentElt = elt;
    let currentOffsetElt = elt;
    while (currentElt && !Utils.hasSelector(currentElt, selector)) {
      if (currentOffsetElt !== currentElt.offsetParent) {
        ret.left += currentOffsetElt.offsetLeft;
        ret.top += currentOffsetElt.offsetTop;
        currentOffsetElt = currentElt.offsetParent as HTMLElement;
      }
      currentElt = currentElt.parentElement as HTMLElement;
    }
    if (currentElt) {
      ret.bottom = currentElt.scrollHeight - ret.top;
      ret.right = currentElt.scrollWidth - ret.left;
    }
    return ret;
  }

  static hasSelector(elt: HTMLElement, selector: string): boolean {
    if (selector.startsWith('.')) {
      const className = selector.replace('.', '');
      return elt.className.indexOf(className) >= 0;
    }
  }
}
